import React from 'react';
import PropTypes from 'prop-types';

import Selector from './selector';
import { countryOptions } from '../packs/helpers/form_support';

class CountrySelector extends Selector {
  constructor(props) {
    super(props);

    this.state.placeholder = 'Country';
    this.state.options = countryOptions();
  }
}

CountrySelector.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default CountrySelector;
